import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { Role } from '../constants/role'
import Swal from '../../node_modules/sweetalert2/dist/sweetalert2'
import VueBodyClass from 'vue-body-class'
import { AuthService } from '../service/auth.service'

const DEFAULT_TITLE = 'iSkin尚行美健康聯合診所'
const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/wscreen',
        name: 'WScreen',
        component: () => import('@/views/WScreen.vue'),
        meta: {
            title: '前台總控',
            authorize: [Role.Admin, Role.FrontDesk, Role.Admin2, Role.FrontDesk2],
        },
    },
    {
        path: '/nscreen',
        name: 'NScreen',
        component: () => import('@/views/NScreen.vue'),
        meta: {
            title: '預約報到',
            authorize: [Role.Admin, Role.Staff, Role.FrontDesk, Role.Admin2, Role.Staff2, Role.FrontDesk2],
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: {
            title: '登入',
        },
    },
    // {
    //     path: '/daily-report',
    //     name: 'DailyReport',
    //     component: () => import('@/views/DailyReport.vue'),
    //     meta: {
    //         title: '總表',
    //         authorize: [Role.Admin, Role.Staff, Role.FrontDesk],
    //     },
    // },
    {
        path: '/daily-report-medical',
        name: 'DailyReportMedical',
        component: () => import('@/views/DailyReportMedical.vue'),
        meta: {
            title: '醫療總表',
            authorize: [Role.Admin, Role.Staff, Role.FrontDesk, Role.Admin2, Role.Staff2, Role.FrontDesk2],
        },
    },
    {
        path: '/daily-report-beauty',
        name: 'DailyReportBeauty',
        component: () => import('@/views/DailyReportBeauty.vue'),
        meta: {
            title: '美療總表',
            authorize: [Role.Admin, Role.Staff, Role.FrontDesk, Role.Admin2, Role.Staff2, Role.FrontDesk2],
        },
    },
    {
        path: '/daily-stock-notify',
        name: 'DailyStockNotify',
        component: () => import('@/views/DailyStockNotify.vue'),
        meta: {
            title: '備貨統計表',
            authorize: [Role.Admin, Role.Staff, Role.FrontDesk, Role.Admin2, Role.Staff2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    // Admin Section
    {
        path: '/admin',
        redirect: '/admin/login',
    },
    {
        path: '/admin/login',
        name: 'AdminLogin',
        component: () => import('@/views/admin/Login.vue'),
        meta: {
            title: '後台登入',
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/clients',
        name: 'AdminClients',
        component: () => import('@/views/admin/Clients.vue'),
        meta: {
            title: '客戶管理',
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/clients/:clientId',
        name: 'AdminClientDetail',
        props: true,
        component: () => import('@/views/admin/ClientDetail.vue'),
        meta: {
            title: '客戶管理',
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/staffs',
        name: 'AdminStaffs',
        component: () => import('@/views/admin/Staffs.vue'),
        meta: {
            title: '員工管理',
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/staffs/:staffId',
        name: 'AdminStaffDetail',
        props: true,
        component: () => import('@/views/admin/StaffDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/staffs/:staffId/report',
        name: 'AdminStaffReport',
        props: true,
        component: () => import('@/views/admin/StaffReport.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/spots',
        name: 'AdminSpots',
        component: () => import('@/views/admin/Spots.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/spots/:spotId',
        name: 'AdminSpotDetail',
        props: true,
        component: () => import('@/views/admin/SpotDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/equipment-categories',
        name: 'AdminEquipmentCategories',
        component: () => import('@/views/admin/EquipmentCategories.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/equipment-categories/:equipmentCategoryId',
        name: 'AdminEquipmentCategoryDetail',
        props: true,
        component: () => import('@/views/admin/EquipmentCategoryDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/equipment',
        name: 'AdminEquipment',
        component: () => import('@/views/admin/Equipments.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/equipment/:equipmentId',
        name: 'AdminEquipmentDetail',
        props: true,
        component: () => import('@/views/admin/EquipmentDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/treatment-types',
        name: 'AdminTreatmentTypes',
        component: () => import('@/views/admin/TreatmentTypes.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/treatment-types/:treatmentTypeId',
        name: 'AdminTreatmentTypeDetail',
        props: true,
        component: () => import('@/views/admin/TreatmentTypeDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/treatments',
        name: 'AdminTreatments',
        component: () => import('@/views/admin/Treatments.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/treatments/:treatmentId',
        name: 'AdminTreatmentDetail',
        props: true,
        component: () => import('@/views/admin/TreatmentDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-time',
        name: 'AdminTreatmentTime',
        component: () => import('@/views/admin/TreatmentTime.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/vacation',
        name: 'AdminVacation',
        component: () => import('@/views/admin/Vacation.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/users',
        name: 'AdminUsers',
        component: () => import('@/views/admin/Users.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/users/:userId',
        name: 'AdminUserDetail',
        props: true,
        component: () => import('@/views/admin/UserDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-announces',
        name: 'AdminOtherAnnounces',
        component: () => import('@/views/admin/OtherAnnounces.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-announces/:announceId',
        name: 'AdminOtherAnnounceDetail',
        props: true,
        component: () => import('@/views/admin/OtherAnnounceDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/overall-report',
        name: 'AdminOverallReport',
        component: () => import('@/views/admin/OverallReport.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/work-detail-reserve',
        name: 'AdminWorkDetailReserve',
        component: () => import('@/views/admin/WorkDetailReserve.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/work-detail-assign',
        name: 'AdminWorkDetailAssign',
        component: () => import('@/views/admin/WorkDetailAssign.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/work-detail',
        name: 'AdminWorkDetail',
        component: () => import('@/views/admin/WorkDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-message',
        name: 'AdminSmsTemplates',
        component: () => import('@/views/admin/SmsTemplates.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-sms-settings',
        name: 'AdminSmsAutoSettings',
        component: () => import('@/views/admin/SmsAutoSettings.vue'),
        meta: {
            // 櫃檯以上可以檢視,修改在畫面上由 canManage 擋 —— 與後端的授權一致:
            // 查詢開放到櫃檯,變更限主管以上。
            authorize: [
                Role.Admin,
                Role.Admin2,
                Role.Supervisor,
                Role.Staff,
                Role.Staff2,
                Role.FrontDesk,
                Role.FrontDesk2,
            ],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-sms-templates',
        name: 'AdminSmsAutoTemplates',
        component: () => import('@/views/admin/SmsAutoTemplates.vue'),
        meta: {
            // 與設定頁相同:查詢開放到櫃檯,修改在畫面上由 canManage 擋。
            authorize: [
                Role.Admin,
                Role.Admin2,
                Role.Supervisor,
                Role.Staff,
                Role.Staff2,
                Role.FrontDesk,
                Role.FrontDesk2,
            ],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-sms-jobs',
        name: 'AdminSmsJobs',
        component: () => import('@/views/admin/SmsJobs.vue'),
        meta: {
            // 查詢開放到櫃檯 —— 客人打來問「我怎麼沒收到簡訊」時,櫃檯要查得到。
            // 門號依角色遮罩,補發與取消在畫面上由 canManage 擋。
            authorize: [
                Role.Admin,
                Role.Admin2,
                Role.Supervisor,
                Role.Staff,
                Role.Staff2,
                Role.FrontDesk,
                Role.FrontDesk2,
            ],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-sms-no-list',
        name: 'AdminSmsNoList',
        component: () => import('@/views/admin/SmsNoList.vue'),
        meta: {
            // 這一頁是給櫃台用的 —— 名單上的客人要靠他們打電話通知,
            // 所以授權與簡訊發送紀錄一致,開放到櫃檯。
            authorize: [
                Role.Admin,
                Role.Admin2,
                Role.Supervisor,
                Role.Staff,
                Role.Staff2,
                Role.FrontDesk,
                Role.FrontDesk2,
            ],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-yuerong-review',
        name: 'AdminYuerongReview',
        component: () => import('@/views/admin/YuerongReview.vue'),
        meta: {
            // 只到 ADMIN:這一頁上的決定是「這本病歷到底是不是這個客戶」,
            // 判斷錯會把兩個人的資料互相覆寫。而且後端那支端點本來就掛在 ADMIN 之下。
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-message/:templateId',
        name: 'AdminSmsTemplateDetail',
        props: true,
        component: () => import('@/views/admin/SmsTemplateDetail.vue'),
        meta: {
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/other-recovery',
        name: 'AdminBackupRecovery',
        component: () => import('@/views/admin/BackupRecovery.vue'),
        meta: {
            title: '備份與回復',
            authorize: [Role.Admin, Role.Admin2, Role.FrontDesk2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/admin/medical-exceptions',
        name: 'AdminMedicalExceptions',
        component: () => import('@/views/admin/MedicalExceptions.vue'),
        meta: {
            title: '醫療特例管理',
            authorize: [Role.Admin, Role.Admin2],
            bodyClass: 'scroll',
        },
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/login',
        meta: {
            bodyClass: 'scroll',
        },
    },
]

const vueBodyClass = new VueBodyClass(routes)

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes,
})

const checkAuthToken = async (query) => {
    if (!query.token) {
        return undefined
    }
    return await AuthService.authToken(query.token)
}

router.beforeEach(async (to, from, next) => {
    const { authorize } = to.meta
    let currentUser = store.state.auth.user // localStorage.getItem('user')

    // trying to access a restricted page + not logged in
    const loginPath = to.path.includes('admin') ? '/admin/login' : '/login'

    // redirect to login page
    if (authorize) {
        if (!currentUser) {
            currentUser = await checkAuthToken(to.query)
            if (!currentUser) {
                return next(loginPath)
            }
        }
        // check if route is restricted by role
        //
        // 比對改成「使用者的任一角色在允許清單裡」。原本是 authorize.includes(roles[0]),
        // 只看第一個角色 —— 而 roles 來自後端的 Set,順序不保證,多角色帳號的行為會飄。
        const myRoles = currentUser.roles || []
        if (authorize.length && !authorize.some((role) => myRoles.includes(role))) {
            Swal.fire({ title: '權限不足', icon: 'warning' })
            // 已經登入、只是這一頁沒權限 -> 留在原地。
            //
            // 原本一律導回登入頁,使用者看到的是「被登出了」,而 session 其實還在。
            // 從別頁點過來就取消這次導航(next(false));直接開網址進來時沒有來源頁,
            // 取消會停在空白,那種情況才回登入頁。
            return next(from.name ? false : loginPath)
        }
    }
    window.document.title = to.meta.title ? `${to.meta.title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE
    vueBodyClass.guard(to, next)
    // next() // will be done by vueBodyClass.guard
})

export default router
